
import { useState, useEffect } from "react";
import { fetchAmenities, Amenity } from "../api/amenitiesAPI";
import { useToast } from "@/hooks/use-toast";

export const useAmenities = () => {
  const [amenities, setAmenities] = useState<Amenity[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();
  
  useEffect(() => {
    const getAmenities = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        const amenitiesData = await fetchAmenities();
        if (amenitiesData.length === 0) {
          console.warn("No amenities found from API");
        }
        setAmenities(amenitiesData);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : "Failed to load amenities";
        console.error("Error loading amenities:", errorMessage);
        setError(errorMessage);
        
        toast({
          title: "Error loading amenities",
          description: "Unable to load amenities. Default options will be used.",
          variant: "destructive",
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    getAmenities();
  }, [toast]);
  
  return { amenities, isLoading, error };
};
